import React from 'react'

export default function Line() {
  return (
    <div className="absolute w-full border-b-4 border-solid border-radium-green bottom-[-0.2rem] left-0"></div>
  )
}
